import Cookies from 'universal-cookie';
import DOMPurify from 'dompurify';
export const cookies = new Cookies();
// cookies.set('myCat', 'Pacman', { path: '/' });
// console.log(cookies.get('myCat')); 

export const page_url = `https://lannainfo.library.cmu.ac.th/lannafood/`;
// export const page_url = 'http://localhost:3000/lannafood/';

// export const img_url = 'http://localhost/2024lannafood/api/images/';
// export const media_url = 'http://localhost/2024lannafood/api/media/';
export const img_url = `https://lannainfo.library.cmu.ac.th/2024lannafoodapi/images/`;
export const media_url = `https://lannainfo.library.cmu.ac.th/2024lannafoodapi/media/`;
export const month_th = [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
export const month_th_mini = [ "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
export const month_en = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const month_en_mini = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];
export const month_cn = ["一月", "二月", "三月", "四月", "五月", "六月", "七月","八月", "九月", "十月", "十一月", "十二月"];

export function addLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, '0');
}

// export const login_url = "https://oauth.cmu.ac.th/v1/Authorize.aspx?response_type=code&client_id=fPtkhqsZufuMDp2xw3UTFt06beeyBC22Mpe3Pthj&redirect_uri=https://lannainfo.library.cmu.ac.th/api/callback&scope=cmuitaccount.basicinfo&state=admin";
// export const login_url = "https://oauth.cmu.ac.th/v1/Authorize.aspx?response_type=code&client_id=fPtkhqsZufuMDp2xw3UTFt06beeyBC22Mpe3Pthj&redirect_uri=http://localhost/nurse/api/callback&scope=cmuitaccount.basicinfo&state=admin";

export const api_url = 'https://lannainfo.library.cmu.ac.th/2024lannafoodapi/';
// export const api_url = `http://localhost/2024lannafood/api/`;

const auth_url = 'https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/authorize';
const client_id = 'b13f2bb8-6181-4eac-95b4-a7d4bc799fde';
const redirect_uri = api_url+'callback';
const scope = 'api://cmu/Mis.Account.Read.Me.Basicinfo';

export const login_url = auth_url+"?response_type=code&client_id="+client_id+"&redirect_uri="+redirect_uri+"&scope="+scope+"&state=admin";

export function chk_img(img){
    if(img && img !== undefined){
        return img_url + img;
    }else{
        return img_url + 'no-img.gif';
    }
}

export function lang(name_th, name_en, name_ch){
    let language = localStorage.getItem("lang");
    if(language===null){
        language = "th";
        localStorage.setItem("lang","th");
    } 
    if(!name_th){ name_th=''; }
    if((name_en===''||name_en===null)&&language==='en'){
        name_en = name_th;
        localStorage.setItem("warning",true);
    }

    switch(language) {
        case 'en':
            return DOMPurify.sanitize(name_en || '');
        case 'cn':
            return DOMPurify.sanitize(name_ch || ''); 
        default:
            return DOMPurify.sanitize(name_th || '');
    }
}

export function getDate(event_date){
    if(event_date==='0000-00-00'){
        return '-';
    }
    let day_name = event_date.substr(8,2);
    let year_name = Number(event_date.substr(0,4));
    let event_month = Number(event_date.substr(5,2))-1;
    let month_name = lang(month_th[event_month], month_en[event_month], month_en[event_month]);

    let language = localStorage.getItem("lang");
    if(language==='en'){
        return day_name+' '+month_name+' '+year_name;
    }else{
        year_name = year_name+543;
        return day_name+' '+month_name+' '+year_name;
    }
}
export function thDateFormat(input_date){
    if(!input_date||input_date==='0000-00-00'){
        return '-';
    }
    var date = new Date(input_date);

    // var year = date.getFullYear()+543;
    var year = date.getFullYear();
    var month = month_th[date.getMonth()];
    var day = date.getDate();

    return day + " " + month + " " + year + "  "
}
export function enDateFormat(input_date){
    if(input_date==='0000-00-00'){
        return '-';
    }
    var date = new Date(input_date);

    var year = date.getFullYear();
    var month = month_en[date.getMonth()];
    var day = date.getDate();

    return day + " " + month + " " + year + "  "
}

export function cnDateFormat(input_date){
    var date = new Date(input_date);

    var y_num = ["〇","一","二","三","四","五","六","七","八","九","十","十一"]
    var d_num = ["零","一","二","三","四","五","六","七","八","九","十",
                "十一","十二","十三","十四","十五","十六","十七","十八","十九","二十",
                "二十一","二十二","二十三","二十四","二十五","二十六","二十七","二十八","二十九","三十",
                "三十一"]
    let y_tmp = String(date.getFullYear());
    let y = [...y_tmp]
    var year = y_num[y[0]]+y_num[y[1]]+y_num[y[2]]+y_num[y[3]];
    var month = month_cn[date.getMonth()];
    var day = d_num[date.getDate()];

    return year + "年 " + month + " " + day + "日  "
}

export function getTextSize(){
    let body_text = "text-small";
    let type = cookies.get('text-size');
    if(type==='large'){
        body_text="text-large";
    }else if(type==='normal'){
        body_text="text-normal";
    }
    return body_text;
}
export function gotoURL(url){
    if(url&&url.charAt(0)==="/"){
        window.location = page_url+url.substring(1);
    }else{
        window.location = page_url;
    }
}
export function gotoLink(url){
    if(url){
        window.open(url);
    }else{
        window.open(page_url);
    }
}

export function openLink(e){
    e.preventDefault();
    let url = e.currentTarget.getAttribute('data-href');
    window.open(url);
}

export function check_brightness(color) {
    if(!color){
        // console.log(color);
        return true;
    }
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
}
export const validateEmail = (mail) => {
  return String(mail)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export const validatePhone = (phone) => {
  // (123) 456-7890
  // (123)456-7890
  // 123-456-7890
  // 123.456.7890
  // 1234567890
  // +31636363634
  // 075-63546725
  return String(phone)
    .toLowerCase()
    .match(
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    );
};
export function openPopup(theURL,winName1,w,h) {
    // set properties for the editace window
    //alert(theURL);
    //alert(a);
    // var lp = (screen.width) ? (screen.width-w)/2 : 0;
    // var tp = (screen.height) ? (screen.height-h)/2 : 0;
    const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop

    var OpenWindow;
    let attrs = 'height=' + h + ',width=' + w + ',top='+top+',left='+left+', resizable=no, toolbar=no , scrollbars=no , status=no';
    OpenWindow = window.open(  theURL , winName1 , attrs);
    OpenWindow.focus();
}